import { render, staticRenderFns } from "./CampaignListGridFooter.vue?vue&type=template&id=3d18491e"
import script from "./CampaignListGridFooter.vue?vue&type=script&lang=js"
export * from "./CampaignListGridFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports